
import * as ipxRuntime$aFQQfGOx0R from '/builds/lottocom/shop-frontend/frontend/node_modules/.pnpm/@nuxt+image@1.9.0_db0@0.2.3_ioredis@5.4.2_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$aFQQfGOx0R, defaults: {} }
}
        